import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent, CircularProgress, Alert } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import useUnitStore from '../store/useUnitStore';
import useNotificationStore from '../store/useNotificationStore';
import RantingTable from './RantingTable';
import RantingForm from './RantingForm';

const RantingManagement = () => {
  const { rantingUnits, mwcUnits, loading, error, fetchRanting, addRanting, updateRanting, removeRanting, fetchMwc } = useUnitStore();
  const showNotification = useNotificationStore((state) => state.showNotification);

  const [openForm, setOpenForm] = useState(false);
  const [selectedRanting, setSelectedRanting] = useState(null);

  useEffect(() => {
    fetchRanting();
    fetchMwc(); // Fetch MWC units for the dropdown in RantingForm
  }, [fetchRanting, fetchMwc]);

  const handleOpenAddForm = () => {
    setSelectedRanting(null);
    setOpenForm(true);
  };

  const handleOpenEditForm = (ranting) => {
    setSelectedRanting(ranting);
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setSelectedRanting(null);
  };

  const handleSaveRanting = async (data) => {
    try {
      if (selectedRanting) {
        await updateRanting(selectedRanting.id, data);
        showNotification('Unit Ranting berhasil diperbarui', 'success');
      } else {
        await addRanting(data);
        showNotification('Unit Ranting berhasil ditambahkan', 'success');
      }
      handleCloseForm();
    } catch (err) {
      showNotification(`Gagal menyimpan Ranting: ${err.message}`, 'error');
    }
  };

  const handleDeleteRanting = async (id) => {
    if (window.confirm('Apakah Anda yakin ingin menghapus unit Ranting ini? Ini akan menghapus semua Pengguna terkait.')) {
      try {
        await removeRanting(id);
        showNotification('Unit Ranting berhasil dihapus', 'success');
      } catch (err) {
        showNotification(`Gagal menghapus Ranting: ${err.message}`, 'error');
      }
    }
  };

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error: {error}</Alert>;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Daftar Ranting</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpenAddForm} disabled={mwcUnits.length === 0}>Tambah Ranting</Button>
      </Box>
      <RantingTable rantingUnits={rantingUnits} onEdit={handleOpenEditForm} onDelete={handleDeleteRanting} />

      <Dialog open={openForm} onClose={handleCloseForm} fullWidth maxWidth="sm">
        <DialogTitle>{selectedRanting ? 'Edit Ranting' : 'Tambah Ranting'}</DialogTitle>
        <DialogContent>
          <RantingForm initialData={selectedRanting} mwcUnits={mwcUnits} onSave={handleSaveRanting} onCancel={handleCloseForm} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default RantingManagement;
